import { useEffect, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { OAuth2 } from '../../services/McDataServices'
import { useToast } from './useToast'

export const useGmailOAuth = (t) => {
  const location = useLocation()
  const navigate = useNavigate()

  const { showSuccess, showError } = useToast()

  const params = useMemo(() => new URLSearchParams(location.search), [location.search])

  const code = useMemo(() => params.get('code'), [params])
  const state = useMemo(() => params.get('state'), [params])

  useEffect(() => {
    if (!code || !state) return

    const handleGmailCallback = async () => {
      try {
        const response = await OAuth2.GmailCallback({ code, state })

        if (response) {
          showSuccess(t('gmail.success'))
        } else {
          showError(t('gmail.error'))
        }
      } catch (err) {
        showError(t('gmail.error'))
      } finally {
        const currentPath = location.pathname
        navigate(currentPath, { replace: true })
      }
    }

    handleGmailCallback()
  }, [code, state, showSuccess, showError, t, navigate, location.pathname])

  return { code, state }
}
